import { type RouteRecordRaw } from 'vue-router'

const usersRoutes: Array<RouteRecordRaw> = [
  {
    path: '/settings/users',
    name: 'users.index',
    component: () => import('@/modules/user/user/views/UsersIndex.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumbs: ['Users']
    }
  },
  {
    path: '/settings/users/:id/show',
    name: 'users.show',
    component: () => import('@/modules/user/user/views/UsersShow.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumbs: ['Users']
    }
  },
  {
    path: '/settings/users/create',
    name: 'users.create',
    component: () => import('@/modules/user/user/views/UsersEdit.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumbs: ['Users']
    }
  },
  {
    path: '/settings/users/:id/edit',
    name: 'users.edit',
    component: () => import('@/modules/user/user/views/UsersEdit.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumbs: ['Users']
    }
  },
  {
    path: '/user/profile',
    name: 'user.profile',
    component: () => import('@/modules/user/user/views/UsersProfile.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumbs: ['Users']
    }
  },
  {
    path: '/user/edit-password',
    name: 'users.edit-password',
    component: () => import('@/modules/user/user/views/UsersEditPassword.vue'),
    meta: { title: 'Edit password' },
    props: true
  }
]

export default usersRoutes
